var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSection1BackCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 407,
    viewBox: "0 0 335 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 203.5,
    r: 203.5,
    fill: "url(#paint0_radial_710_682)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_710_682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.5 203.5) rotate(90) scale(225.382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDFBE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDFBE0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSection1BackCircle);
export default __webpack_public_path__ + "static/media/MainSection1_BackCircle.8ca26479b1c449296d4b91c7f9d86c5d.svg";
export { ForwardRef as ReactComponent };